import { NOOP } from '@/utils';
import * as types from '../mutation-types';

const state = {

    cloudHost: '',

    willShow: true,

    topInfo: {

        type: '',
        msgIndex: '',
        icon: true,
        operation: NOOP,
        closeOperation: NOOP

    }

};

type TTopInfoState = typeof state;

const mutations = {

    [ types.SETTOPINFO ]( state: TTopInfoState, topInfo: TTopInfoState['topInfo'] ): void {

        state.topInfo = { ...state.topInfo, ...topInfo };

    },

    [ types.SETCLOUDHOST ]( state: TTopInfoState, cloudHost: string ): void {

        state.cloudHost = cloudHost;

    },

    [ types.CLOSETOPINFO ]( state: TTopInfoState ): void {

        state.topInfo = {

            type: '',
            msgIndex: '',
            icon: false,
            operation: NOOP,
            closeOperation: NOOP

        };

    },

    [ types.OPENWILLSHOW ]( state: TTopInfoState ): void {

        state.willShow = true;

    },

    [ types.CLOSEWILLSHOW ]( state: TTopInfoState ): void {

        state.willShow = false;

    }

};

const getters = {

    topInfo: ( state: TTopInfoState ): TTopInfoState['topInfo'] => state.topInfo,
    cloudHost: ( state: TTopInfoState ): string => state.cloudHost

};

export default {

    state,
    mutations,
    getters

};
